import { I18n } from "@assets/strings";
import React, { useState } from "react";
import styled from "styled-components";
import { Person } from "@domain/user/user";
import { gap } from "@ui/styles/utils";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { Tertiary } from "@ui/components/containers/textBlocks";
import { ChevronDownIcon } from "@ui/components/icons";
import { row, Spacer } from "@ui/components/layout";
import { UserView } from "@ui/components/profile/userView";

interface PersonSelectorProps extends React.HTMLAttributes<HTMLDivElement> {
	items: Person[];
	onItemChange: (item?: Person) => void;
	current?: Person;
	onlyOrganizations?: boolean;
}
export const PersonSelector: React.FC<PersonSelectorProps> = ({
	current,
	items,
	onItemChange,
	onlyOrganizations,
	...htmlProps
}) => {
	const [opened, setOpened] = useState(false);

	return (
		<Container {...htmlProps}>
			<Selected onClick={() => setOpened((o) => !o)}>
				{current ? (
					<UserView disabled user={current} pictureSize={40} />
				) : (
					<Tertiary>{I18n.t("profile.selector.placeholder")}</Tertiary>
				)}
				<Spacer />
				<div>
					<ChevronDownIcon reversed={opened} />
				</div>
			</Selected>
			{opened
				? items
						.filter((person) => !current || person.id !== current.id)
						.map((person) =>
							person ? (
								<div
									key={person.id}
									style={{ cursor: "pointer" }}
									onClick={() => {
										onItemChange(onlyOrganizations && person.type === "USER" ? undefined : person);
										setOpened(false);
									}}
								>
									<UserView disabled user={person} pictureSize={40} />
								</div>
							) : (
								<></>
							)
						)
				: null}
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 15px 16px;
	${gap(30)};
`;

const Selected = styled.div`
	${row(6, "flex-start", "center")};
	cursor: pointer;

	> svg {
		display: block;
		margin-bottom: 2px;

		path {
			fill: ${({ theme }) => theme.colors.secondary};
		}
	}
`;
